/**
 * avatars/items/shared.js
 * Các hàm tiện ích dùng chung cho AvatarItemsLibrary
 */

import * as THREE from 'three';

/**
 * Chọn màu trong bảng có khoảng cách RGB xa nhất so với màu áo
 * @param {string} baseColor
 * @param {string[]} palette
 * @returns {string}
 */
export function pickContrastColor(baseColor, palette) {
  const base = new THREE.Color(baseColor);
  let best = palette[0];
  let bestDist = -1;
  palette.forEach((c) => {
    const col = new THREE.Color(c);
    const dist = (col.r - base.r) ** 2 + (col.g - base.g) ** 2 + (col.b - base.b) ** 2;
    if (dist > bestDist) {
      bestDist = dist;
      best = c;
    }
  });
  return best;
}

/**
 * Quai mũ ôm má: 2 dây chạy từ mép vành phía SAU TAI chéo xuống phía trước tới góc cằm,
 * 1 dây ngang dưới cằm (đặt sát NGOÀI mặt đầu để không xuyên vào mặt hay lơ lửng trong đầu)
 */
export function addChinStrap(lib, hatGroup, headSize, topY, material, withBuckle = false) {
  const half = headSize / 2;
  const off = 0.012;
  const chinY = 0.02;
  const strapThick = 0.022;

  // Dây má trái & phải
  [-1, 1].forEach((side) => {
    const startX = side * (half + off);
    const startZ = -headSize * 0.04;
    const endX = side * (half * 0.72 + off);
    const endY = chinY + 0.04;
    const endZ = headSize * 0.12;

    const dx = endX - startX;
    const dy = endY - topY;
    const dz = endZ - startZ;
    const len = Math.sqrt(dx * dx + dy * dy + dz * dz);

    const geo = new THREE.BoxGeometry(strapThick, len, strapThick);
    const mesh = new THREE.Mesh(geo, material);
    mesh.position.set((startX + endX) / 2, (topY + endY) / 2, (startZ + endZ) / 2);
    mesh.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), new THREE.Vector3(dx, dy, dz).normalize());
    hatGroup.add(mesh);
    if (lib && lib.disposables) lib.disposables.push(geo);
  });

  // Dây ngang ôm dưới cằm
  const bottomW = headSize * 0.74;
  const bottomGeo = new THREE.BoxGeometry(bottomW, strapThick, strapThick * 1.2);
  const bottomMesh = new THREE.Mesh(bottomGeo, material);
  bottomMesh.position.set(0, chinY, headSize * 0.12);
  hatGroup.add(bottomMesh);
  if (lib && lib.disposables) lib.disposables.push(bottomGeo);

  // Khóa cài quai mũ
  if (withBuckle) {
    const buckleGeo = new THREE.BoxGeometry(strapThick * 1.5, strapThick * 1.4, strapThick * 1.5);
    const buckleMat = new THREE.MeshStandardMaterial({ color: '#a1a1aa', metalness: 0.8, roughness: 0.25 });
    const buckle = new THREE.Mesh(buckleGeo, buckleMat);
    buckle.position.set(bottomW * 0.35, chinY, headSize * 0.125);
    hatGroup.add(buckle);
    if (lib && lib.disposables) lib.disposables.push(buckleGeo, buckleMat);
  }
}
